import React from "react";
import { useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Container, Typography, Box } from "@mui/material";

import { writeData } from "../functions/writeData";

import { useNavigate } from "react-router-dom";

export default function AddNewCategory() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    await writeData("contact", data);
    alert("Message has been Sent.");
    navigate("/");
  };

  return (
    <Container sx={{ my: 2 }} maxWidth="sm">
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold" }}
      >
        Contact Us
      </Typography>
      <Typography variant="subtitle2" color="secondary">
        If you have any query related to our write down your query
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box>
          <TextField
            {...register("email", { required: true })}
            label="Enter Email"
            style={{ marginTop: 10 }}
            fullWidth
            type="email"
            color="primary"
          />
          {errors.email && (
            <Typography color="error">Email is required</Typography>
          )}
        </Box>
        <Box>
          <TextField
            {...register("description", { required: true })}
            label="Enter Description"
            style={{ marginTop: 10 }}
            fullWidth
            color="primary"
            multiline
            rows={3}
          />
          {errors.description && (
            <Typography color="error">Description is required</Typography>
          )}
        </Box>
        <Box>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: "20px" }}
          >
            Send
          </Button>
        </Box>
      </form>
    </Container>
  );
}
